import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "data-test-ref": "email-body" }
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-circle-check fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "mr-1" }
const _hoisted_6 = {
  key: 0,
  "data-test-ref": "email-resent-message"
}
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-circle-check fa-lg mr-3" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "mr-1" }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "mr-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_15 = { class: "d-flex justify-content-end my-4" }

import { useI18n, createNamespacedT } from '@/i18n';
import { ref } from 'vue';
import { useLedsService } from 'commercial-web-client-utilities/dist/composables/leds-service';
import { useNonsecureService } from 'commercial-web-client-utilities/dist/composables/nonsecure-service';
import { dateFormat } from 'commercial-web-client-utilities';
import * as logger from 'commercial-web-client-utilities/dist/logging/logger';
import { useSiteConfig } from '@/composables/site-config';
import { createMemberProfileRecoveryService, SecureLinkOptions } from '@/composables/profile-recovery-service';
import { useAppStore } from '@/store';
import { useForgotUsernameValidations } from '@/composables/forgot-username-validations';


export default /*#__PURE__*/_defineComponent({
  __name: 'sent-email',
  setup(__props) {

const i18n = useI18n();
const ledsService = useLedsService();
const siteConfig = useSiteConfig();
const appStore = useAppStore();
const nonsecureService = useNonsecureService();
const tNamespace = 'forgotUsername';
const tns = createNamespacedT(i18n, tNamespace);
const profileRecoveryService = createMemberProfileRecoveryService({
    ledsService,
    nonsecureService,
});

const forgotUsernameValidations = useForgotUsernameValidations();

const showResentMessage = ref(false);
const loading = ref(false);

async function resendEmail() {
    loading.value = true;
    const firstName = forgotUsernameValidations.state.firstName;

    try {
        const request = forgotUsernameValidations.state.ssn.length > 0
            ? {
                withSocialSecurityNumber: {
                    socialSecurityNumber: forgotUsernameValidations.state.ssn.replaceAll('-', ''),
                    dateOfBirth: dateFormat(forgotUsernameValidations.state.dob, 'YYYY-MM-DD'),
                    ...(firstName.length > 0 && { firstName }),
                }
            }
            : {
                withIdCardNumber: {
                    idCardNumber: forgotUsernameValidations.state.memberId,
                    dateOfBirth: dateFormat(forgotUsernameValidations.state.dob, 'YYYY-MM-DD'),
                    firstName: forgotUsernameValidations.state.firstName,
                    ...(firstName.length > 0 && { firstName }),
                },
            } as SecureLinkOptions;

        const res = await profileRecoveryService.secureLink(request);
        if (res.data.emailDomain) showResentMessage.value = true;
        return res;
    } catch (err) {
        logger.log(err);
    } finally {
        loading.value = false;
    }
}

const navigateToLogin = () => {
    window.location.href = appStore.logoutUrl ?? '';
};

return (_ctx: any,_cache: any) => {
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_link = _resolveComponent("b-link")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_overlay = _resolveComponent("b-overlay")!

  return (_openBlock(), _createBlock(_component_b_overlay, {
    show: loading.value,
    variant: "light",
    opacity: "0.75",
    rounded: "sm",
    "spinner-variant": "primary",
    "data-test-ref": "member-forgot-username-loading-overlay"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_b_alert, {
          variant: "success",
          show: true
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(tns)('email.body')), 1 /* TEXT */)
              ])
            ])
          ], undefined, true),
          _: 1 /* STABLE */
        })
      ]),
      (showResentMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_b_alert, {
              variant: "success",
              show: showResentMessage.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(tns)('email.resent')), 1 /* TEXT */)
                  ])
                ])
              ], undefined, true),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_i18n_t, {
              keypath: "forgotUsername.techSupport.emailSupport",
              tag: "span"
            }, {
              resend: _withCtx(() => [
                _createVNode(_component_b_link, {
                  "data-test-ref": "resend-email-button",
                  onClick: _withModifiers(resendEmail, ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tns)('techSupport.resend')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              visitSupport: _withCtx(() => [
                _createVNode(_component_b_link, {
                  "data-test-ref": "member-forgot-username-technical-support",
                  target: "_blank",
                  onClick: _unref(siteConfig).redirectToTechSupport
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tns)('techSupport.visitSupport')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              phoneNumber: _withCtx(() => [
                _createVNode(_component_b_link, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(tns)('techSupport.phoneNumber')), 1 /* TEXT */)
                  ], undefined, true),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ])
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_b_button, {
          variant: "primary",
          onClick: navigateToLogin
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(tns)('email.returnToLogin')), 1 /* TEXT */)
          ], undefined, true),
          _: 1 /* STABLE */
        })
      ])
    ], undefined, true),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}
}

})